<div class="overlay" (click)="toggleModal()"></div>
<div class="container flex-column m-0 p-0 d-flex">
  <div class="row g-0 m-0 p-4 justify-content-start borderb">
    <div class="col-md-11 ps-2 d-flex justify-content-start">
      <span class="popup-title">{{ "MEMBERDETAILS" | translate }}</span>
    </div>
    <div class="col-md-1 d-flex justify-content-end" (click)="toggleModal()">
      <svg-icon
      alt="Exit"
        class="exit"
        role="button"
        src="assets/device/exit.svg"
      ></svg-icon>
    </div>
  </div>
  <div class="row g-0 m-0 body p-4 pt-5">
    <div class="member-details p-4">
      <div class="row g-0 m-0">
        <div class="row d-flex g-0 p-0">
          <div
            class="g-0 p-0 d-flex justify-content-center align-items-center member-picture"
            [ngStyle]="{
              'background-color': backgroundColors[0],
            }"
          >
            <span class="item-title">{{ member.firstName![0] }}</span>
          </div>
          <div>
            <span class="item-title pb-5 pt-2"
              >{{ member.firstName }} {{ member.lastName }}</span
            >
          </div>
        </div>

        <div class="row g-0 m-0 pt-2 pb-2">
          <div class="col-md-6">
            <span class="item-name">{{ "ROLE" | translate }}</span>
          </div>
          <div class="col-md-6">
            <span class="item-info">
              {{ member.role }}
              @if (member.roleStatus != RoleStatus.Active){
                <span class="status"
                  [ngClass]="{
                  pending: member.roleStatus === RoleStatus.Pending,
                  inactive: member.roleStatus === RoleStatus.Inactive,
                }"> {{ member.roleStatus }}</span>
              }
            </span>
          </div>
        </div>
        <div
          class="row g-0 m-0 pt-2 pb-2 d-flex justify-content-start align-items-center"
        >
          <div class="col-md-6">
            <span class="item-name">{{ "STATUS" | translate }}</span>
          </div>
          <div class="col-md-6 d-flex">
            <span
              class="status"
              [ngClass]="{
                active: member.status === 'Active',
                pending: member.status === 'Pending',
                inactive: member.status === 'Inactive',
              }"
              >{{ member.status }}</span
            >
          </div>
        </div>
        <div
          class="row g-0 m-0 pt-2 pb-2 justify-content-start align-items-center"
        >
          <div class="col-md-6">
            <span class="item-name">{{ "EMAIL" | translate }}</span>
          </div>
          <div class="col-md-6">
            <span class="item-info">{{ member.email }}</span>
          </div>
        </div>
        <div
          class="row g-0 m-0 pt-2 pb-2 justify-content-start align-items-center"
        >
          <div class="col-md-6">
            <span class="item-name">{{ "PHONENUMBER" | translate }}</span>
          </div>
          <div class="col-md-6">
            <span class="item-info">{{ member.phoneNumber ? member.phoneNumber : '/'}}</span>
          </div>
        </div>
        <div class="row g-0 m-0 pt-2 pb-2 justify-content-start">
          <div class="col-md-6">
            <span class="item-name">{{ "CREATEDBY" | translate }}</span>
          </div>
          <div class="col-md-6">
            <span class="item-info">{{ member.createdByUserEmail }}</span>
          </div>
        </div>
        <div class="row g-0 m-0 pt-2 pb-2 justify-content-start">
          <div class="col-md-6">
            <span class="item-name">{{ "DATEADDED" | translate }}</span>
          </div>
          <div class="col-md-6">
            <span class="item-info">{{
              member.createdTime | date: "d MMMM, y"
            }}</span>
          </div>
        </div>
        <div class="row g-0 m-0 pt-2 pb-2 justify-content-start">
          <div class="col-md-6">
            <span class="item-name">{{
              "DEVICESETUP_DEVICEADDRESS" | translate
            }}</span>
          </div>
          <div class="col-md-6">
            <span class="item-info">{{ member.address }}</span>
          </div>
        </div>
        @if (member.regionName) {
          <div class="row g-0 m-0 pt-2 pb-2 justify-content-start">
            <div class="col-md-6">
              <span class="item-name">{{
                "DEVICESETUP_REGION" | translate
              }}</span>
            </div>
            <div class="col-md-6">
              <span class="item-info">{{ member.regionName }}</span>
            </div>
          </div>
        }
        @if (member.areaNames) {
          <div class="row g-0 m-0 pt-2 justify-content-start">
            <div class="col-md-6">
              <span class="item-name">{{ "DISTRICT" | translate }}</span>
            </div>
            <div class="col-md-6">
              <span
                class="label-box-information"
                *ngFor="let area of member.areaNames; let i = index"
                [ngStyle]="{ 'background-color': backgroundColors[i] }"
              >
                {{ area }}
              </span>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="row g-0 m-0 p-3 align-items-end bordert mt-auto">
    <div
      class="col-md-9 pt-2 pb-2 ps-2 d-flex justify-content-start"
      (click)="toggleModal()"
    >
      <span role="button" class="item-name">{{
        "CLOSE_WINDOW" | translate
      }}</span>
    </div>
  </div>
</div>
